import React, {useEffect, useRef, useState} from "react";
import {Button, Container, Image, Nav, Navbar, NavLink} from 'react-bootstrap';
import Routes from "./router";
import './App.css';
import LocalDataService from "./api/LocalDataService";
import ApiService from "./api/ApiService";
import UserProfile from "./components/loginModal/UserProfile";
import UserInfoPopup from "./components/userInfo/UserInfoPopup";
import {toast, ToastContainer} from "react-toastify";
import AIKefu from "./components/AIKefu/AIKefu";
import {useLocation} from "react-router-dom";
import { getCurrentDomainConfig } from "./utils/domainConfig";

function App() {
    const userProfileRef = useRef(null);
    const userInfoPopupRef = useRef(null);
    const apiService = new ApiService();
    const [isMobile, setIsMobile] = useState(false);
    const [user, setUser] = useState(null);
    const location = useLocation(); // 使用 hook 获取 location
    useEffect(() => {
        console.log("App loaded"); // Debug log to confirm App.js is reloaded

        apiService.setUserProfileRef(userProfileRef);

        // 检测是否为移动设备
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        // 监听用户登录状态变化
        const handleUserLoginStatusChange = () => {
            const userData = LocalDataService.load_user_data();
            setUser(userData);
        };

        // 初始加载用户数据
        handleUserLoginStatusChange();

        // 添加事件监听器
        window.addEventListener('userLoginStatusChanged', handleUserLoginStatusChange);

        return () => {
            window.removeEventListener('resize', checkMobile);
            window.removeEventListener('userLoginStatusChanged', handleUserLoginStatusChange);
        };
    }, []);
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const codeParam = searchParams.get('inviteCode');
        if (codeParam) {
            // toast.info(codeParam);
            LocalDataService.setInviteCode(codeParam)
        }
    }, [location.search]);

    const handleNavLinkClick = (e, route) => {
        if (route == '/vipCenter' || route == '/cozeList' || route == '/promotion' || route == '/sign') {
            let user_info = LocalDataService.load_user_data();
            let loginData = LocalDataService.load_login_data();
            // 假设 LocalDataService 中有一个方法来检查用户是否已登录
            if (!user_info || !loginData) {
                e.preventDefault(); // 阻止链接默认行为
                userProfileRef.current.showLoginModal(false);
                // 如果用户未登录，重定向到登录页面
            }
        }
    };
    const handleClickLogin = () => {
        LocalDataService.set_user_data(null);
        LocalDataService.set_login_data(null);
        userProfileRef.current.showLoginModal(false);
    };
    const handleUserClick = (e) => {
        userInfoPopupRef.current.togglePopup(e);
    };

    return (
        <div className="App">
            <Navbar fixed={'top'} expand="lg" className='navigation' style={{backgroundColor: '#020308'}}>
                <Container className={'container-xxl bd-gutter flex-wrap flex-lg-nowrap'}>
                    <Navbar.Brand to="/home" href='/home'
                                  style={{color: '#02C8E3', marginLeft: '12px', display: 'flex', alignItems: 'center'}}>
                        <img src="/images/logo.svg" width={30} alt={getCurrentDomainConfig().siteName} style={{marginRight: '8px'}}></img>{getCurrentDomainConfig().siteName}
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-toggler"/>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="navigation-tab" variant="underline" defaultActiveKey={'/home'}
                             activeKey={window.location.pathname}>
                            <NavLink className='tab-info' href='/home' eventKey="/home"
                                     onClick={(e) => handleNavLinkClick(e, '/home')}
                                     activeClassName="active-link" onSelect={(e) => e.preventDefault()}>首页</NavLink>
                            <NavLink className='tab-info' href='/cozeList' eventKey="/cozeList"
                                     onClick={(e) => handleNavLinkClick(e, '/cozeList')}
                                     activeClassName="active-link"
                                     onSelect={(e) => e.preventDefault()}>智能体执行</NavLink>

                            <NavLink className='tab-info' href='/courseList' eventKey="/courseList"
                                     onClick={(e) => handleNavLinkClick(e, '/courseList')}
                                     activeClassName="active-link"
                                     onSelect={(e) => e.preventDefault()}>课程学堂</NavLink>
                            <NavLink className='tab-info' href='/promotion' eventKey="/promotion"
                                     onClick={(e) => handleNavLinkClick(e, '/promotion')}
                                     activeClassName="active-link"
                                     onSelect={(e) => e.preventDefault()}>推广赚钱</NavLink>
                            <NavLink className='tab-info' href='/sign' eventKey="/sign"
                                     onClick={(e) => handleNavLinkClick(e, '/sign')}
                                     activeClassName="active-link"
                                     onSelect={(e) => e.preventDefault()}>签到</NavLink>
                            <Button className='vip-tab-info' href='/vipCenter' eventKey="/vipCenter"
                                    onClick={(e) => handleNavLinkClick(e, '/vipCenter')}
                                    activeClassName="active-link">
                                <Image src="/images/vip_icon.svg" width={36} alt='会员'
                                       style={{marginRight: '6px'}}/>{user?.vip?.level > 0 ? '会员中心' : '购买会员'}
                            </Button>
                            {(!LocalDataService.load_login_data() || !LocalDataService.load_user_data()) &&
                                <Button className='user-tab-info' eventKey="/userInfo"
                                        onClick={(e) => handleClickLogin()}
                                        activeClassName="active-link"
                                        onSelect={(e) => e.preventDefault()}>
                                    注册/登录
                                </Button>
                            }
                            {LocalDataService.load_login_data() && LocalDataService.load_user_data() &&
                                <Image
                                    src={user && user.user?.avatar ? user.user?.avatar : "/images/default_user.svg"}
                                    roundedCircle={true}
                                    onClick={(e) => handleUserClick(e)}
                                    style={{width: '40px', height: '40px', alignSelf: 'center'}}
                                />
                            }
                        </Nav>

                        <UserInfoPopup ref={userInfoPopupRef} userProfileRef={userProfileRef}/>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <div className={isMobile ? 'mobile-content' : 'content'}>
                <Routes userProfileRef={userProfileRef}/>
                {/* 确保 UserProfile 组件正确渲染并接收 ref */}
                <UserProfile ref={userProfileRef}/>
            </div>
            <ToastContainer style={{top: '55px'}}/>
            <AIKefu/>
        </div>
    );
}

export default App;